import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor() { }

  encrypt(value) {
    return CryptoJS.Rabbit.encrypt(
      value.toString(),
      environment.secure
    ).toString();
  }

  decrypt(textToDecrypt) {
    return CryptoJS.Rabbit.decrypt(textToDecrypt, environment.secure).toString(
      CryptoJS.enc.Utf8
    );
  }

  decryptObject(arrayEncrypted) {
    const dataArray = Object.entries(arrayEncrypted);
    const stringObject = {};
    dataArray.forEach((info, value) => {
      stringObject[info[0]] = this.decrypt(info[1]);
    });
    return stringObject;
  }

  encryptObject(arrayEncrypted) {
    const dataArray = Object.entries(arrayEncrypted);
    const stringObject = {};
    dataArray.forEach((info, value) => {
      if (typeof (info[1]) == 'object') {
        if (info[1] instanceof Array) {
          stringObject[info[0]] = this.encrypt(JSON.stringify(info[1]));
        } else {
          stringObject[info[0]] = info[1];
        }
      } else {
        stringObject[info[0]] = this.encrypt(info[1]);
      }
    });
    return stringObject;
  }

  castToMultipart(arrayEncrypted) {
    const dataArray = Object.entries(arrayEncrypted);
    const stringObject = new FormData();
    dataArray.forEach((info, value) => {
      if (typeof (info[1]) == 'object') {
        if (info[1] instanceof Array) {
          stringObject.append(info[0], info[1] as unknown as string);
        } else {
          stringObject.append(info[0], info[1] as Blob);
        }
      } else {
        stringObject.append(info[0], info[1] as string);
      }
    });
    return stringObject;
  }

  decryptObjectArray(arrayEncryptedA) {
    const newObjectArray = [];
    arrayEncryptedA.forEach((arrayEncrypted) => {
      const dataArray = Object.entries(arrayEncrypted);
      const stringObject = {};
      dataArray.forEach((info, value) => {
        stringObject[info[0]] = this.decrypt(info[1]);
      });
      newObjectArray.push(stringObject);
    });

    return newObjectArray;
  }
}
